import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { CoordinatorTypes } from 'modules/domain/user/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { stringify } from 'query-string'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import FormSelectShared from 'views/components/FormSelectShared'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent, SharedModalInputs } from 'views/components/SharedModal'
import { SampleRequestType } from 'views/pages/Samples/types'
import { CommonFormFields } from './CommonFormFields'
import { AddSampleRequestFields } from './AddSampleRequestModal'

const regionalSelectFilters = { coordinator_type: [CoordinatorTypes.regional, CoordinatorTypes.senior_regional] }

type Props = {
  sampleRequest: SampleRequestType
  onClose: () => void
  refetch: () => void
}

type FormFields = AddSampleRequestFields & { regional: string | null }

export const EditSampleRequestModal: FC<Props> = ({ onClose, refetch, sampleRequest }) => {
  const { t } = useTranslation('deal')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<FormFields>({
    initialValues: {
      bid: sampleRequest.bid,
      deal: sampleRequest.deal,
      senior_regional: sampleRequest?.senior_regional.id,
      regional: sampleRequest.regional?.id ?? null,
      quantity: sampleRequest.quantity,
      product: sampleRequest.product.id,
      seller_user: sampleRequest.seller_user.id,
      seller_address: sampleRequest.seller_address.id,
      phone: sampleRequest.seller_user.phone,
      laboratory: sampleRequest.laboratory,
      lab_comment: sampleRequest.lab_comment,
      lab_assistant: sampleRequest.lab_assistant?.id ?? null,
      comment: sampleRequest?.comment ?? null,
      analysis_type: sampleRequest.analysis_type ?? null,
    },

    onSubmit: formHandler(() => apiClient.put(endpoints.sampleRequest(sampleRequest?.id), formik.values), {
      onSuccess: async () => {
        await refetch()
        onClose()
      },
      onError: (error) => {
        const { errors } = error
        formik.setErrors(errors)
      },
    }),
  })

  return (
    <ResponsiveModal
      id="editSampleRequest"
      title={t('accordion.sample.sampleRequest')}
      progress={formProgress}
      onConfirm={formik.submitForm}
      onClose={onClose}
      size="large"
      disabled={!formik.dirty}
    >
      <SharedModalContent>
        <SharedModalInputs>
          <CommonFormFields formik={formik}>
            <FormSelectShared
              label={t('accordion.sample.regional')}
              formik={formik}
              endpoint={`${endpoints.coordinatorsShort()}?${stringify(regionalSelectFilters)}`}
              fieldName="regional"
              getLabel={(dto) => dto.full_name}
              placeholder=""
              searchField="search"
            />
          </CommonFormFields>
        </SharedModalInputs>
      </SharedModalContent>
    </ResponsiveModal>
  )
}
